import { convertISODateTimeStringToISODate } from 'common/helpers/dateHelper';

export const createSearchString = (params, settings) => {
  let urlString;
  urlString = `reservationDate=${createReservationDate(
    params.reservationDate,
    params.reservationTime,
    settings
  )}`;

  urlString += `&guestCount=${params.guestCount}`;

  if (params.reservationTypeId) {
    urlString += `&reservationTypeId=${params.reservationTypeId}`;
  }
  return urlString;
};

export const createReservationDate = (date, time, settings) => {
  const reservationDate = convertISODateTimeStringToISODate(
    date,
    time,
    settings
  );
  return reservationDate;
};

export const urlHistoryString = (params) => {
  let historyString = `reservationDate=${params.reservationDate}`;
  historyString += `&guestCount=${params.guestCount}`;
  historyString += `&reservationTime=${params.reservationTime}`;
  if (params.reservationTypeId) {
    historyString += `&reservationTypeId=${params.reservationTypeId}`;
  }
  return historyString;
};
